module.exports = "/static/Images/en/Eight.png";